import React from "react";
import { css } from "@emotion/react";
import {
  Label,
  Font,
} from "@moneyforward/mfx_biz_react_components";
import { FormErrorMessage, FormFormattableTextField } from "@/components/molecules";
import { useIsSpMode } from "@/hooks";
import { capitalValidation } from "@/components/validations";

type Props = {
  name: string;
  labelRequired: boolean;
};

const capitalFormField = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          資本金 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormFormattableTextField
            name={props.name}
            textAlign="right"
            formatType="decimal"
            placeholder={"例）1,000"}
            registerOptions={{
              validate: capitalValidation,
            }}
            ref={ref}
          />
          <FormErrorMessage name={props.name} />
        </div>
        <div css={unitWrapper}>
          <Font variant="m">万円</Font>
        </div>
      </div>
    </div>
  );
};

export const CapitalFormField = React.forwardRef(capitalFormField);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  display: "flex",
  alignItems: "center",
});

const textFieldWrapper = css({
  maxWidth: "196px",
});

const unitWrapper = css({
  marginLeft: "16px",
});
